import React from 'react'
import Main from './Components/Main'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Routes
} from "react-router-dom";
import Home from './Pages/1. Top Header/Home/home'
import Navbar from './Components/Navbar';
import Activities from './Pages/1. Top Header/Activities/activities'
import Facilities from "./Pages/1. Top Header/Facilities/facilities"
import Alumini from "./Pages/1. Top Header/Alumni/alumini"
import Grievances from './Pages/2. Center Header/Grievances/grievances'
import NIRF from './Pages/2. Center Header/NIRF/nirf'
import MoE from './Pages/2. Center Header/MoE/moe'
import Payment from './Pages/2. Center Header/Online Payment/onlinepayment'
import Exam from './Pages/2. Center Header/Exam/exam'
import Research from './Pages/2. Center Header/Research/research'
import IQAC from './Pages/2. Center Header/IQAC/iqac'
import Objectives from './Pages/2. Center Header/IQAC/Iqac-Pages/Objectives/Objectives';
import AQARREPORTS from './Pages/2. Center Header/IQAC/Iqac-Pages/AQAR REPORTS/AQAR REPORTS';
import BestPractices from './Pages/2. Center Header/IQAC/Iqac-Pages/Best Practices - IQAC/BestPractices';
import DATATEAMMEMBERS from './Pages/2. Center Header/IQAC/Iqac-Pages/DATA TEAM MEMBERS - IQAC/DATATEAMMEMBERS';
import DepartmentofAide from './Pages/2. Center Header/IQAC/Iqac-Pages/Department of Aide/DepartmentofAide';
import Distinctiveness from './Pages/2. Center Header/IQAC/Iqac-Pages/Distinctiveness - IQAC/Distinctiveness';
import FEEDBACK from './Pages/2. Center Header/IQAC/Iqac-Pages/FEEDBACK - IQAC/FEEDBACK';
import IQACCoreCommitteMembers from './Pages/2. Center Header/IQAC/Iqac-Pages/IQAC Core Committe Members/IQACCoreCommitteMembers';
import IQACMeetings from './Pages/2. Center Header/IQAC/Iqac-Pages/IQAC Meetings/IQACMeetings';
import NAACCertificate from './Pages/2. Center Header/IQAC/Iqac-Pages/NAAC Certificate/NAACCertificate';
import PeerTeamReports from './Pages/2. Center Header/IQAC/Iqac-Pages/Peer Team Reports/PeerTeamReports';
import Policies from './Pages/2. Center Header/IQAC/Iqac-Pages/Policies/Policies';
import QualityInitiatives from './Pages/2. Center Header/IQAC/Iqac-Pages/Quality Initiatives/QualityInitiatives';
import QualityPolicy from './Pages/2. Center Header/IQAC/Iqac-Pages/Quality Policy/QualityPolicy';
import RoleOfHonour from './Pages/2. Center Header/IQAC/Iqac-Pages/Role Of Honour/RoleOfHonour';
import SelfStudyReport from './Pages/2. Center Header/IQAC/Iqac-Pages/Self Study Report/SelfStudyReport';
import StudentsSatisfactionSurvey from './Pages/2. Center Header/IQAC/Iqac-Pages/Students Satisfaction Survey - IQAC/StudentsSatisfactionSurvey';
import VisionMission from './Pages/2. Center Header/IQAC/Iqac-Pages/Vision & Mission/VisionMission';
import Measi from './DropDown/DropDown_Pages/About_Pages/Measi';
import TheNewCollege from './DropDown/DropDown_Pages/About_Pages/TheNewCollege';
import Adminstration from './DropDown/DropDown_Pages/About_Pages/Adminstration';
import Autonomy from './DropDown/DropDown_Pages/About_Pages/Autonomy';
import NAAC from './DropDown/DropDown_Pages/About_Pages/NAAC';
import NIRF_About from './DropDown/DropDown_Pages/About_Pages/NIRF_About';
import AISHE from './DropDown/DropDown_Pages/About_Pages/AISHE';
import CodeofConduct from './DropDown/DropDown_Pages/About_Pages/CodeofConduct';
import GeneralInstruction from './DropDown/DropDown_Pages/Admission_Pages/GeneralInstruction';
import FeeStructure from './DropDown/DropDown_Pages/Admission_Pages/FeeStructure';
import RulesRegulations from './DropDown/DropDown_Pages/Admission_Pages/RulesRegulations';
import AdmissionPolicy from './DropDown/DropDown_Pages/Admission_Pages/AdmissionPolicy';
import AdmissionCommittee from './DropDown/DropDown_Pages/Admission_Pages/AdmissionCommittee';
import OnlineApplications from './DropDown/DropDown_Pages/Admission_Pages/OnlineApplications';
import Departments from './DropDown/DropDown_Pages/Acadamic_Pages/Departments';
import Faculty from './DropDown/DropDown_Pages/Acadamic_Pages/Faculty';
import AdministrativeStaff from './DropDown/DropDown_Pages/Acadamic_Pages/AdministrativeStaff';
import Programmes from './DropDown/DropDown_Pages/Acadamic_Pages/Programmes';
import Syllabus from './DropDown/DropDown_Pages/Acadamic_Pages/Syllabus';
import ProgrammeOutcomes from './DropDown/DropDown_Pages/Acadamic_Pages/ProgrammeOutcomes';
import PhysicalEducation from './DropDown/DropDown_Pages/Acadamic_Pages/PhysicalEducation';
import AcademicCalender from './DropDown/DropDown_Pages/Acadamic_Pages/AcademicCalender';
import PlacementCell from './DropDown/DropDown_Pages/Services_Pages/PlacementCell';
import Scholarship from './DropDown/DropDown_Pages/Services_Pages/Scholarship';
import CapacityDevelopment from './DropDown/DropDown_Pages/Services_Pages/CapacityDevelopment';
import StudentsUnion from './DropDown/DropDown_Pages/Services_Pages/StudentsUnion';
import GrievanceRequest from './DropDown/DropDown_Pages/Services_Pages/GrievanceRequest';
import StaffAssociation from './DropDown/DropDown_Pages/Services_Pages/StaffAssociation';
import IIEC from './DropDown/DropDown_Pages/Services_Pages/IIEC';
import Employee from './DropDown/DropDown_Pages/Feedback_Pages/Employee';
import Parents from './DropDown/DropDown_Pages/Feedback_Pages/Parents';
import Students from './DropDown/DropDown_Pages/Feedback_Pages/Students';
import Alumni from './DropDown/DropDown_Pages/Feedback_Pages/Alumni';
import StudentFacultyLogin from './DropDown/DropDown_Pages/QuickLink_Pages/StudentFacultyLogin';
import OnlinePayment from './DropDown/DropDown_Pages/QuickLink_Pages/OnlinePayment';
import Library from './DropDown/DropDown_Pages/QuickLink_Pages/Library';
import EducationVerification from './DropDown/DropDown_Pages/QuickLink_Pages/EducationVerification';
import Grievance from './DropDown/DropDown_Pages/QuickLink_Pages/Grievance';
import Download from './DropDown/DropDown_Pages/QuickLink_Pages/Download';
import ScholarshipsandFellowships from './DropDown/DropDown_Pages/QuickLink_Pages/ScholarshipsandFellowships';
import AttendanceReport from './DropDown/DropDown_Pages/QuickLink_Pages/AttendanceReport';
import English from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/English';
import Tamil from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Tamil';
import Arabic from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Arabic';
import Urdu from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Urdu';
import Hindi from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Hindi';
import French from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/French';
import HistoricalStudies from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/HistoricalStudies';
import Economics from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Economics';
import Sociology from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Sociology';
import Commerce from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Commerce';
import CorporateSecretaryship from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/CorporateSecretaryship';
import Mathematics from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Mathematics';
import Physics from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Physics';
import Chemistry from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Chemistry';
import Botany from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Botany';
import Zoology from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Zoology';
import ComputerScience from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/ComputerScience';
import ComputerApplications from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/ComputerApplications';
import InformationSystems from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/InformationSystems';
import BusinessAdministration from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/BusinessAdministration';
import BankManagement from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/BankManagement';
import Biotechnology from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/Biotechnology';
import InformationTechnology from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/InformationTechnology';
import AccountingFinance from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/AccountingFinance';
import CriminologyPoliceAdministration from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/CriminologyPoliceAdministration';
import DefenceStrategicStudies from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/DefenceStrategicStudies';
import ElectronicMedia from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/ElectronicMedia';
import ProfessionalAccounting from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/ProfessionalAccounting';
import ArtificialIntelligence from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/ArtificialIntelligence';
import DataScience from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/DataScience';
import DeptPE from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/DeptPE';
import ShiftILibrary from './DropDown/DropDown_Pages/Acadamic_Pages/Department_Pages/ShiftILibrary';


const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Home />}> </Route>
          <Route path='/activies' element={<Activities />}></Route>
          <Route path='/facilities' element={<Facilities />}></Route>
          <Route path='/alumini' element={<Alumini />}></Route>
          {/* This is the second navbar Link */}
          <Route path='/grievances' element={<Grievances />}></Route>
          <Route path='/nirf' element={<NIRF />}></Route>
          <Route path='/moe' element={<MoE />}></Route>
          <Route path='/payment' element={<Payment />}></Route>
          <Route path='/exam' element={<Exam />}></Route>
          <Route path='/research' element={<Research />}></Route>
          <Route path='/iqac' element={<IQAC />}></Route>

          {/* This is the IQAC Pages Link */}
          <Route path='/Objectives' element={<Objectives />}></Route>
          <Route path='/AQAR REPORTS' element={<AQARREPORTS />}></Route>
          <Route path='/BestPractices' element={<BestPractices />}></Route>
          <Route path='/DATATEAMMEMBERS' element={<DATATEAMMEMBERS />}></Route>
          <Route path='/DepartmentofAide' element={<DepartmentofAide />}></Route>
          <Route path='/Distinctiveness' element={<Distinctiveness />}></Route>
          <Route path='/FEEDBACK' element={<FEEDBACK />}></Route>
          <Route path='/IQACCoreCommitteMembers' element={<IQACCoreCommitteMembers />}></Route>
          <Route path='/NAACCertificate' element={<NAACCertificate />}></Route>
          <Route path='/Policies' element={<Policies />}></Route>
          <Route path='/PeerTeamReports' element={<PeerTeamReports />}></Route>
          <Route path='/QualityInitiatives' element={<QualityInitiatives />}></Route>
          <Route path='/QualityPolicy' element={<QualityPolicy />}></Route>
          <Route path='/RoleOfHonour' element={<RoleOfHonour />}></Route>
          <Route path='/SelfStudyReport' element={<SelfStudyReport />}></Route>
          <Route path='/StudentsSatisfactionSurvey' element={<StudentsSatisfactionSurvey />}></Route>
          <Route path='/VisionMission' element={<VisionMission />}></Route>
          <Route path='/IQACMeetings' element={<IQACMeetings />}></Route>


          {/* This is the About Dropdown Pages */}
          <Route path='/measi' element={<Measi />}></Route>
          <Route path='/the new college' element={<TheNewCollege />}></Route>
          <Route path='/adminstration' element={<Adminstration />}></Route>
          <Route path='/autonomy' element={<Autonomy />}></Route>
          <Route path='/naac' element={<NAAC />}></Route>
          <Route path='/nirfa' element={<NIRF_About />}></Route>
          <Route path='/aishe' element={<AISHE />}></Route>
          <Route path='/codeofconduct' element={<CodeofConduct />}></Route>


          {/* This is the Admission Dropdown Pages */}
          <Route path='/generalinstruction' element={<GeneralInstruction />}></Route>
          <Route path='/Fee Structure' element={<FeeStructure />}></Route>
          <Route path='/Rules & Regulations' element={<RulesRegulations />}></Route>
          <Route path='/Admission Policy' element={<AdmissionPolicy />}></Route>
          <Route path='/Admission Policy' element={<AdmissionPolicy />}></Route>
          <Route path='/Admission Committee' element={<AdmissionCommittee />}></Route>
          <Route path='/Online Applications' element={<OnlineApplications />}></Route>

          {/* This is the Acadamic DropDown Pages */}
          <Route path='/Departments' element={<Departments />}></Route>
          <Route path='/Faculty' element={<Faculty />}></Route>
          <Route path='/Administrative Staff' element={<AdministrativeStaff />}></Route>
          <Route path='/Programmes' element={<Programmes />}></Route>
          <Route path='/Syllabus' element={<Syllabus />}></Route>
          <Route path='/Programme Outcomes' element={<ProgrammeOutcomes />}></Route>
          <Route path='/Physical Education' element={<PhysicalEducation />}></Route>
          <Route path='/Academic Calender' element={<AcademicCalender />}></Route>


          {/* This is the Services DropDown Pages */}
          <Route path='/Placement Cell' element={<PlacementCell />}></Route>
          <Route path='/Scholarship' element={<Scholarship />}></Route>
          <Route path='/Capacity Development' element={<CapacityDevelopment />}></Route>
          <Route path='/Students Union' element={<StudentsUnion />}></Route>
          <Route path='/Grievance / Request' element={<GrievanceRequest />}></Route>
          <Route path='/Staff Association' element={<StaffAssociation />}></Route>
          <Route path='/IIEC' element={<IIEC />}></Route>

          {/* This is the Feedback Pages */}
          <Route path='/Employee' element={<Employee />}></Route>
          <Route path='/Parents' element={<Parents />}></Route>
          <Route path='/Students' element={<Students />}></Route>
          <Route path='/Alumni' element={<Alumni />}></Route>


          {/* This is the QuickLinks DropDown Pages */}
          <Route path='/SFlogin' element={<StudentFacultyLogin />}></Route>
          <Route path='/onlinepayment' element={<OnlinePayment />}></Route>
          <Route path='/Library' element={<Library />}></Route>
          <Route path='/everification' element={<EducationVerification />}></Route>
          <Route path='/Grievance' element={<Grievance />}></Route>
          <Route path='/download' element={<Download />}></Route>
          <Route path='/Scholarships and Fellowships' element={<ScholarshipsandFellowships />}></Route>
          <Route path='/Attendance Report' element={<AttendanceReport />}></Route>


          {/* This is the Department Pages List */}
          <Route path='/English' element={<English />}></Route>
          <Route path='/Tamil' element={<Tamil />}></Route>
          <Route path='/Arabic' element={<Arabic />}></Route>
          <Route path='/Urdu' element={<Urdu/>}></Route>
          <Route path='/Hindi' element={<Hindi />}></Route>
          <Route path='/French' element={<French />}></Route>
          <Route path='/Historical Studies' element={<HistoricalStudies />}></Route>
          <Route path='/Economics' element={<Economics />}></Route>
          <Route path='/Sociology' element={<Sociology />}></Route>
          <Route path='/Commerce' element={<Commerce />}></Route>
          <Route path='/Corporate Secretaryship' element={<CorporateSecretaryship />}></Route>
          <Route path='/Mathematics' element={<Mathematics />}></Route>
          <Route path='/Physics' element={<Physics />}></Route>
          <Route path='/Chemistry' element={<Chemistry />}></Route>
          <Route path='/Botany' element={<Botany />}></Route>
          <Route path='/Zoology' element={<Zoology />}></Route>
          <Route path='/Computer Science' element={<ComputerScience />}></Route>
          <Route path='/Computer Applications' element={<ComputerApplications />}></Route>
          <Route path='/Information Systems Management' element={<InformationSystems />}></Route>
          <Route path='/Business Administration' element={<BusinessAdministration />}></Route>
          <Route path='/Bank Management' element={<BankManagement />}></Route>
          <Route path='/Biotechnology' element={<Biotechnology />}></Route>
          <Route path='/Information Technology' element={<InformationTechnology />}></Route>
          <Route path='/Accounting & Finance' element={<AccountingFinance />}></Route>
          <Route path='/Criminology & Police Administration' element={<CriminologyPoliceAdministration />}></Route>
          <Route path='/Defence & Strategic Studies' element={<DefenceStrategicStudies />}></Route>
          <Route path='/Electronic Media' element={<ElectronicMedia />}></Route>
          <Route path='/Professional Accounting' element={<ProfessionalAccounting />}></Route>
          <Route path='/Artificial Intelligence' element={<ArtificialIntelligence />}></Route>
          <Route path='/Data Science' element={<DataScience />}></Route>
          <Route path='/Dept-PE' element={<DeptPE />}></Route>
          <Route path='/ShiftI-Library' element={<ShiftILibrary />}></Route>


        </Routes>

      </Router>
    </>
  )
}

export default App
